import _ from 'lodash'
import $ from 'jquery'
import { DirectiveOptions, VNode, VNodeDirective } from 'vue'

/**
 * documentがクリックされたときに関数を実行するディレクティブ。
 * 例えば、ドキュメントをクリックしたときにドロップダウンメニューを隠すのに使う。
 */
const options: DirectiveOptions = {
  bind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
    const handler = function (event: JQuery.Event<HTMLElement>) {
      if (el === event.target || $(el).find(event.target).length !== 0) {
        // クリックされたのが自分自身の場合、documentがクリックされたとみなさない。
        // el のクリックイベントだけを実行するようにする。
        return
      }
      if (!_.isFunction(binding.value)) {
        console.error(`v-${binding.name} の引数には、関数を指定してください。`)
      }
      binding.value()
    }
    $(el).data('cm.click-document', handler)
    $(document).on('click', handler)
  },
  unbind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
    $(document).off('click', $(el).data('cm.click-document'))
    $(el).removeData('cm.click-document')
  }
}

export default options
